import { SET_SELECTED_DEVICE } from "../../constants/ActionTypes";

export const SelectedDeviceId = (payload, name) => {
  return { type: SET_SELECTED_DEVICE, deviceId: payload, deviceName: name };
};

